import { Suspense } from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from 'atoms/loader/LoadingIndicator';
import { Dialog } from 'components/dialog';
import { useIsLaptop } from 'hooks/device/useIsLaptop';
import { lazy } from 'lib/retry';

const MultiSportSearchBar = lazy(
  async () => import('components/search/MultiSportSearchBar'),
  'MultiSportSearchBar'
);

const StyledDialog = styled(Dialog)`
  top: 0;
  padding: var(--unit);
  margin: 0 auto auto auto;
`;

type Props = { onClose?: () => void };
export const SearchBarDialog = ({ onClose }: Props) => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <StyledDialog
      open
      onClose={onClose}
      fullScreen={!isLaptopAndAbove}
      maxWidth="xs"
      fullWidth
      hideHeader
    >
      <div className="forceSearchbarForDesktop">
        <Suspense fallback={<LoadingIndicator />}>
          <MultiSportSearchBar
            onExit={false}
            onSelect={() => onClose?.()}
            onClose={onClose}
          />
        </Suspense>
      </div>
    </StyledDialog>
  );
};
